import PropTypes from 'prop-types';
import React from 'react';
import { Size } from '../../constants/components';
import { actionOnKeyboardPress } from '../utils/browserUtils';

export const WORD_ANSWER = 'WORD_ANSWER';
export const LETTER_ANSWER = 'LETTER_ANSWER';

export default class TextAnswer extends React.Component {
    getStyles() {
        const buttonStyle = this.props.answerType === WORD_ANSWER ? 'nwf-button' : 'letter-button';
        const statusStyle = this.props.isDisabled ? ' disabled-button' : '';
        const selectedStyle = this.props.isSelected ? ' selected' : '';
        const fontStyle = this.props.fontSize === Size.LARGE ? '' : 'reduced';
        return `${buttonStyle} ${statusStyle} ${selectedStyle} ${fontStyle}`;
    }

    render() {
        return (
            <div
                tabIndex={this.props.isTabIndexDisabled ? '-1' : 0}
                role="button"
                className={this.getStyles()}
                onKeyDown={e => actionOnKeyboardPress(e, () => this.props.onAnswerClick())}
                onClick={this.props.onAnswerClick}
            >
                {this.props.text}
            </div>
        );
    }
}

TextAnswer.propTypes = {
    text: PropTypes.string.isRequired,
    answerType: PropTypes.string,
    fontSize: PropTypes.string,
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isTabIndexDisabled: PropTypes.bool,
    onAnswerClick: PropTypes.func,
};

TextAnswer.defaultProps = {
    isSelected: false,
    isDisabled: false,
    isTabIndexDisabled: false,
    answerType: WORD_ANSWER,
    fontSize: Size.LARGE,
    onAnswerClick: () => {},
};
